export const MAGIC_WINDOW_LOADED = 'MAGIC_WINDOW_LOADED'
export const MAGIC_WINDOW_CLOSE = 'MAGIC_WINDOW_CLOSE'
export const MAGIC_WINDOW_GA_TRACKING = 'MAGIC_WINDOW_GA_TRACKING'
export const MAGIC_WINDOW_FULL_SCREEN = 'MAGIC_WINDOW_FULL_SCREEN'
export const MAGIC_WINDOW_MODAL_SCREEN = 'MAGIC_WINDOW_MODAL_SCREEN'
export const GET_TOKENS = 'GET_TOKENS'
export const GET_TOKENS_RESPONSE = 'GET_TOKENS_RESPONSE'
export const NAVIGATE_BACK = 'NAVIGATE_BACK'
export const SET_RESUME_PARAM = 'SET_RESUME_PARAM'
